import hasVisibleLabel from '../../../utils/material/has-visible-label';
import { MaterialLabel } from '../../../utils/material/material-labels.constants';
import showQualityBadge from '../../../utils/material/show-quality-badge';

const useMaterialLabelVisibility = (item: Material, label: MaterialLabel): boolean =>
    hasVisibleLabel({
        label,
        showQualityLabel: showQualityBadge(item),
        hasSaleOriginalPrice: Boolean(item.sale?.original_price)
    });

export default useMaterialLabelVisibility;
